import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';
import { KeepAlive } from 'vue';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/authLogin',
    component: () => import('@/pages/login/authLogin.vue'),
    name: 'authLogin',
    props: getProps,
    meta: {
      title: '免认证',
    },
  },
  {
    path: '/',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome',
    },
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: 'welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎' },
      },
      {
        path: 'manual',
        component: () => import('@/pages/upms/operationManual/detail.vue'),
        name: 'manual',
        meta: { title: '操作手册' },
      },
      {
        path: 'formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表' },
      },
      {
        path: 'formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表' },
      },
      {
        path: 'formSysDept',
        component: () => import('@/pages/upms/formSysDept/index.vue'),
        name: 'formSysDept',
        meta: { title: '部门列表' },
      },
      {
        path: 'formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理' },
      },
      {
        path: 'formSysDataPerm',
        component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
        name: 'formSysDataPerm',
        meta: { title: '数据权限管理' },
      },
      {
        path: 'formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户' },
      },
      // 岗位模块路由配置
      {
        path: 'formSysPost',
        component: () => import('@/pages/upms/formSysPost/index.vue'),
        name: 'formSysPost',
        meta: { title: '岗位管理' },
      },
      {
        path: 'formSysDeptPost',
        component: () => import('@/pages/upms/formSysDeptPost/index.vue'),
        name: 'formSysDeptPost',
        props: getProps,
        meta: { title: '设置部门岗位' },
      },
      {
        path: 'formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理' },
      },
      {
        path: 'formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志' },
      },
      {
        path: 'operationManual',
        component: () => import('@/pages/upms/operationManual/index.vue'),
        name: 'operationManual',
        meta: { title: '操作手册' },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
      // 在线表单
      {
        path: 'formOnlineDblink',
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
        name: 'formOnlineDblink',
        props: getProps,
        meta: { title: '数据库链接' },
      },
      {
        path: 'formOnlineDict',
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
        name: 'formOnlineDict',
        props: getProps,
        meta: { title: '在线表单字典管理' },
      },
      {
        path: 'formOnlinePage',
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
        name: 'formOnlinePage',
        props: getProps,
        meta: { title: '在线表单管理' },
      },
      {
        path: 'onlineForm',
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
        name: 'onlineForm',
        props: getProps,
        meta: { title: '在线表单' },
      },
      // 工作流模块
      {
        path: 'formMessage',
        component: () => import('@/pages/workflow/formMessage/index.vue'),
        name: 'formMessage',
        props: getProps,
        meta: { title: '催办消息' },
      },
      {
        path: 'formFlowCategory',
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
        name: 'formFlowCategory',
        props: getProps,
        meta: { title: '流程分类管理' },
      },
      {
        path: 'formFlowEntry',
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
        name: 'formFlowEntry',
        props: getProps,
        meta: { title: '流程设计' },
      },
      {
        path: 'formFlowDblink',
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
        name: 'formFlowDblink',
        props: getProps,
        meta: { title: '流程数据库链接' },
      },
      {
        path: 'formAllInstance',
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
        name: 'formAllInstance',
        props: getProps,
        meta: { title: '流程实例' },
      },
      {
        path: 'handlerFlowTask',
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: { title: '流程处理' },
        children: [
          // 静态表单路由设置
        ],
      },
      {
        path: 'formMyTask',
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
        name: 'formMyTask',
        props: getProps,
        meta: { title: '我的待办' },
      },
      {
        path: 'formMyApprovedTask',
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
        name: 'formMyApprovedTask',
        props: getProps,
        meta: { title: '已办任务' },
      },
      {
        path: 'formMyHistoryTask',
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
        name: 'formMyHistoryTask',
        props: getProps,
        meta: { title: '历史流程' },
      },
      {
        path: 'formCostCenter',
        component: () => import('@/pages/generated/formCostCenter.vue'),
        name: 'formCostCenter',
        props: getProps,
        meta: { title: '成本中心管理' },
      },
      {
        path: 'formProduct',
        component: () => import('@/pages/generated/formProduct.vue'),
        name: 'formProduct',
        props: getProps,
        meta: { title: '产品数据管理' },
      },
      {
        path: 'formPlant',
        component: () => import('@/pages/generated/formPlant.vue'),
        name: 'formPlant',
        props: getProps,
        meta: { title: 'Plant管理' },
      },
      {
        path: 'formProductSalesData',
        component: () => import('@/pages/generated/formProductSalesData.vue'),
        name: 'formProductSalesData',
        props: getProps,
        meta: { title: '产品销售数据管理' },
      },
      {
        path: 'listFreeSampleApply',
        component: () => import('@/pages/generated/listFreeSampleApply.vue'),
        name: 'listFreeSampleApply',
        props: getProps,
        meta: { title: '免费申请样品列表', keepAlive: true },
      },
      {
        path: 'formFreeSampleApply',
        component: () => import('@/pages/generated/formFreeSampleApply.vue'),
        name: 'formFreeSampleApply',
        props: getProps,
        meta: { title: '免费样品申请表单' },
      },
      {
        path: 'formSapOrderData',
        component: () => import('@/pages/generated/formSapOrderData.vue'),
        name: 'formSapOrderData',
        props: getProps,
        meta: { title: 'SAP订单数据管理' },
      },
      {
        path: 'formSapPurchaseReceipt',
        component: () => import('@/pages/generated/formSapPurchaseReceipt.vue'),
        name: 'formSapPurchaseReceipt',
        props: getProps,
        meta: { title: '采购入库查询', keepAlive: true },
      },
      {
        path: 'listRefundApply',
        component: () => import('@/pages/generated/listRefundApply.vue'),
        name: 'listRefundApply',
        props: getProps,
        meta: { title: '退换货申请列表', keepAlive: true },
      },
      {
        path: 'formRefundApply',
        component: () => import('@/pages/generated/formRefundApply.vue'),
        name: 'formRefundApply',
        props: getProps,
        meta: { title: '退换货申请表单' },
      },
      {
        path: 'formHospital',
        component: () => import('@/pages/generated/formHospital.vue'),
        name: 'formHospital',
        props: getProps,
        meta: { title: '医疗机构管理' },
      },
      {
        path: 'formFreeSampleAudit',
        component: () => import('@/pages/generated/formFreeSampleAudit.vue'),
        name: 'formFreeSampleAudit',
        props: getProps,
        meta: { title: '免费样品申请审批页面' },
      },
      {
        path: 'purchaseDetail',
        component: () => import('@/pages/generated/purchaseDetail.vue'),
        name: 'purchaseDetail',
        props: getProps,
        meta: { title: '采购入库查询详情页面' },
      },
      {
        path: 'formFreeSamplePdf',
        component: () => import('@/pages/generated/formFreeSamplePdf.vue'),
        name: 'formFreeSamplePdf',
        props: getProps,
        meta: { title: '免费样品申请PDF页面' },
      },
      {
        path: 'formRefundAudit',
        component: () => import('@/pages/generated/formRefundAudit.vue'),
        name: 'formRefundAudit',
        props: getProps,
        meta: { title: '退换货申请审批表单' },
      },
      {
        path: 'formRefundQualityAudit',
        component: () => import('@/pages/generated/formRefundQualityAudit.vue'),
        name: 'formRefundQualityAudit',
        props: getProps,
        meta: { title: '退换货质量审批表单' },
      },
      {
        path: 'formRefundWarehouseAudit',
        component: () => import('@/pages/generated/formRefundWarehouseAudit.vue'),
        name: 'formRefundWarehouseAudit',
        props: getProps,
        meta: { title: '退换货仓库审批表单' },
      },
      {
        path: 'formRefundPdf',
        component: () => import('@/pages/generated/formRefundPdf.vue'),
        name: 'formRefundPdf',
        props: getProps,
        meta: { title: '退换货导出签收单' },
      },
      {
        path: 'formSapPurchasePdf',
        component: () => import('@/pages/generated/formSapPurchasePdf.vue'),
        name: 'formSapPurchasePdf',
        props: getProps,
        meta: { title: '采购入口查询导出签收单' },
      },
      {
        path: 'listBizInstance',
        component: () => import('@/pages/generated/listBizInstance.vue'),
        name: 'listBizInstance',
        props: getProps,
        meta: { title: '已审批' },
      },
      {
        path: 'listTodoBizInstance',
        component: () => import('@/pages/generated/listTodoBizInstance.vue'),
        name: 'listTodoBizInstance',
        props: getProps,
        meta: { title: '待审批' },
      },
      {
        path: 'listDiscardApply',
        component: () => import('@/pages/generated/listDiscardApply.vue'),
        name: 'listDiscardApply',
        props: getProps,
        meta: { title: '报废申请列表', keepAlive: true },
      },
      {
        path: 'formDiscardApply',
        component: () => import('@/pages/generated/formDiscardApply.vue'),
        name: 'formDiscardApply',
        props: getProps,
        meta: { title: '报废申请表单' },
      },
      {
        path: 'formDiscardAudit',
        component: () => import('@/pages/generated/formDiscardAudit.vue'),
        name: 'formDiscardAudit',
        props: getProps,
        meta: { title: '报废申请审批' },
      },
      {
        path: 'formDiscardPdf',
        component: () => import('@/pages/generated/formDiscardPdf.vue'),
        name: 'formDiscardPdf',
        props: getProps,
        meta: { title: '报废申请PDF页面' },
      },
    ],
  },
  // TODO 第三方接入路由
  {
    path: '/thirdParty',
    component: () => import('@/components/thirdParty/index.vue'),
    name: 'thirdParty',
    props: getProps,
    children: [
      // 流程分类列表
      {
        path: 'thirdFormFlowCategory',
        name: 'thirdFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
      },
      // 流程分类 新增、编辑
      {
        path: 'thirdAddFormFlowCategory',
        name: 'thirdAddFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formEditFlowCategory.vue'),
      },
      // 流程实例列表
      {
        path: 'thirdFormAllInstance',
        name: 'thirdFormAllInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
      },
      // 流程图
      {
        path: 'thirdFormTaskProcessViewer',
        name: 'thirdFormTaskProcessViewer',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formTaskProcessViewer.vue'),
      },
      // 流程干涉
      {
        path: 'thirdFormInterposeInstance',
        name: 'thirdFormInterposeInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formInterposeInstance.vue'),
      },
      // 流程复活
      {
        path: 'thirdFormRestartInstance',
        name: 'thirdFormRestartInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formRestart.vue'),
      },
      // 数据补偿
      {
        path: 'thirdFormCompensationInstance',
        name: 'thirdFormCompensationInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/processCompensation.vue'),
      },
      // 流程终止
      {
        path: 'thirdFormStopTaskInstance',
        name: 'thirdFormStopTaskInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/stopTask.vue'),
      },
      // 选择用户-处理用户
      {
        path: 'thirdTaskUserSelect',
        name: 'thirdTaskUserSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskUserSelect.vue'),
      },
      // 选择用户-跳转节点
      {
        path: 'thirdSelectUserTask',
        name: 'thirdSelectUserTask',
        props: getProps,
        component: () => import('@/pages/workflow/components/UserTaskSelect/userTaskSelectDlg.vue'),
      },
      // 流程设计
      {
        path: 'thirdFlowDblink',
        name: 'thirdFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
      },
      {
        path: 'thirdEditFlowDblink',
        name: 'thirdEditFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/editFlowDblink.vue'),
      },
      {
        path: 'thirdFormFlowEntry',
        name: 'thirdFormFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
      },
      {
        path: 'thirdFormEditFlowEntry',
        name: 'thirdFormEditFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntry.vue'),
      },
      {
        path: 'thirdFormPublishedFlowEntry',
        name: 'thirdFormPublishedFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formPublishedFlowEntry.vue'),
      },
      {
        path: 'thirdHandlerFlowTask',
        name: 'thirdHandlerFlowTask',
        props: getProps,
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
      },
      // 流程设计-候选用户组
      {
        path: 'thirdTaskGroupSelect',
        name: 'thirdTaskGroupSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskGroupSelect.vue'),
      },
      // 流程设计-选择岗位
      {
        path: 'thirdTaskPostSelect',
        name: 'thirdTaskPostSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskPostSelect.vue'),
      },
      // 流程设计-抄送
      {
        path: 'thirdAddCopyForItem',
        name: 'thirdAddCopyForItem',
        props: getProps,
        component: () => import('@/pages/workflow/components/CopyForSelect/addCopyForItem.vue'),
      },
      // 流程设计-任务按钮
      {
        path: 'thirdEditOperation',
        name: 'thirdEditOperation',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formEditOperation.vue'),
      },
      // 流程设计-任务表单权限
      {
        path: 'thirdSetOnlineFormAuth',
        name: 'thirdSetOnlineFormAuth',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formSetOnlineFormAuth.vue'),
      },
      // 流程设计-添加变量
      {
        path: 'thirdFormEditFlowEntryVariable',
        name: 'thirdFormEditFlowEntryVariable',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryVariable.vue'),
      },
      // 流程设计- 新建状态
      {
        path: 'thirdFormEditFlowEntryStatus',
        name: 'thirdFormEditFlowEntryStatus',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryStatus.vue'),
      },
      // 流程设计- 任务提交
      {
        path: 'thirdTaskCommit',
        name: 'thirdTaskCommit',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskCommit.vue'),
      },
      // 自动化任务 - 编辑过滤条件
      {
        path: 'thirdEditTableFilter',
        name: 'thirdEditTableFilter',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editSrcTableFilter.vue'),
      },
      // 自动化任务 - 编辑更新字段
      {
        path: 'thirdEditFieldUpdateData',
        name: 'thirdEditFieldUpdateData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editInsertData.vue'),
      },
      // 自动化任务 - 编辑响应字段
      {
        path: 'thirdEditResponseData',
        name: 'thirdEditResponseData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editResponseData.vue'),
      },
      // 自动化任务 - 编辑HTTP请求参数
      {
        path: 'thirdEditHttpRequestParam',
        name: 'thirdEditHttpRequestParam',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpParameter.vue'),
      },
      // 自动化任务 - 编辑HTTP请求头
      {
        path: 'thirdEditHttpHeader',
        name: 'thirdEditHttpHeader',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpHeader.vue'),
      },
      // 自动化任务 - 编辑聚合计算字段
      {
        path: 'thirdEditAggregationData',
        name: 'thirdEditAggregationData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editAggregationData.vue'),
      },
      // 自动化任务 - 编辑计算字段
      {
        path: 'thirdEditFormulaData',
        name: 'thirdEditFormulaData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editFormulaData.vue'),
      },
      // 待办任务
      {
        path: 'thirdFormMyTask',
        name: 'thirdFormMyTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
      },
      // 历史任务
      {
        path: 'thirdFormMyHistoryTask',
        name: 'thirdFormMyHistoryTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
      },
      // 已办任务
      {
        path: 'thirdFormMyApprovedTask',
        name: 'thirdFormMyApprovedTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
      },
      // 在线表单部分
      {
        path: 'thirdOnlineForm',
        name: 'thirdOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
      },
      {
        path: 'thirdOnlineEditForm',
        name: 'thirdOnlineEditForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/OnlineEditForm/index.vue'),
      },
      {
        path: 'thirdFormOnlineDict',
        name: 'thirdFormOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
      },
      {
        path: 'thirdEditOnlineDict',
        name: 'thirdEditOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/EditOnlineDict.vue'),
      },
      {
        path: 'thirdOnlinePage',
        name: 'thirdOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlinePage',
        name: 'thirdEditOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlineForm',
        name: 'thirdEditOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlineForm.vue'),
      },
      {
        path: 'thirdEditPageDatasource',
        name: 'thirdEditPageDatasource',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlinePageDatasource.vue'),
      },
      {
        path: 'thirdEditPageRelation',
        name: 'thirdEditPageRelation',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/editOnlinePageDatasourceRelation.vue'),
      },
      {
        path: 'thirdSetOnlineTableColumnRule',
        name: 'thirdSetOnlineTableColumnRule',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/setOnlineTableColumnRule.vue'),
      },
      {
        path: 'thirdEditVirtualColumnFilter',
        name: 'thirdEditVirtualColumnFilter',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editVirtualColumnFilter.vue'),
      },
      {
        path: 'thirdEditTableColumn',
        name: 'thirdEditTableColumn',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/formDesign/editTableColumn.vue'),
      },
      {
        path: 'thirdEditCustomFormOperate',
        name: 'thirdEditCustomFormOperate',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditCustomFormOperate.vue'),
      },
      {
        path: 'thirdEditFormField',
        name: 'thirdEditFormField',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditFormField.vue'),
      },
      {
        path: 'thirdEditDictParamValue',
        name: 'thirdEditDictParamValue',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/CustomWidgetDictSetting/EditDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn',
        name: 'thirdEditOnlineTableColumn',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel',
        name: 'thirdEditOnlineTabPanel',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdOnlineDblink',
        name: 'thirdOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
      },
      {
        path: 'thirdEditOnlineDblink',
        name: 'thirdEditOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/editOnlineDblink.vue'),
      },
      // 通用
      {
        path: 'thirdEditDictParamValue2',
        name: 'thirdEditDictParamValue2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/CustomWidgetDictSetting/editDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn2',
        name: 'thirdEditOnlineTableColumn2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel2',
        name: 'thirdEditOnlineTabPanel2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
      },
      {
        path: 'thirdSelectData',
        name: 'thirdSelectData',
        props: getProps,
        component: () => import('@/online/components/OnlineCustomDataSelect/DataSelectDlg.vue'),
      },
      {
        path: 'thirdEditCustomEvent',
        name: 'thirdEditCustomEvent',
        props: getProps,
        component: () => import('@/online/components/CustomEventSetting/editCustomEvent.vue'),
      },
    ],
  },
];
